import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useAuth } from "../../context/auth";
import { SUBSCRIPTION_PLAN_ID } from "../../utils/constants";

const PricingPage = ({ setPageTitle }) => {
    const { loginData } = useAuth();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setPageTitle("Pricing");

        // Load Razorpay script
        const script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, [setPageTitle]);

    const handleSubscribe = async () => {
        setLoading(true);
        try {
            // 1. Create Order
            const { data: orderData } = await axios.post("/subscription/order");

            const options = {
                key: import.meta.env.VITE_RAZORPAY_KEY_ID,
                amount: orderData.data.amount,
                currency: orderData.data.currency,
                name: "RayApp Release",
                description: "Artist Pro Subscription",
                order_id: orderData.data.id,
                handler: async function (response) {
                    try {
                        // 2. Verify Payment
                        await axios.post("/subscription/verify", {
                            razorpay_order_id: response.razorpay_order_id,
                            razorpay_payment_id: response.razorpay_payment_id,
                            razorpay_signature: response.razorpay_signature,
                            planId: SUBSCRIPTION_PLAN_ID,
                        });
                        toast.success("Subscription successful!");
                        // Redirect to homepage and refresh to update auth state
                        window.location.href = "/";
                    } catch (error) {
                        console.error(error);
                        toast.error("Payment verification failed");
                    }
                },
                prefill: {
                    name: loginData?.user?.name,
                    email: loginData?.user?.email,
                    contact: loginData?.user?.phone,
                },
                theme: {
                    color: "#3399cc",
                },
            };

            const rzp1 = new window.Razorpay(options);
            rzp1.open();
        } catch (error) {
            console.error(error);
            toast.error("Failed to initiate subscription");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-col items-center justify-center h-full p-8 relative">
            <div className="absolute top-0 left-0 w-full h-full circle-background"></div>
            <div className="max-w-md w-full bg-background rounded-xl border overflow-hidden md:max-w-2xl z-20">
                <div className="md:flex">
                    <div className="p-8 w-full">
                        <div className="uppercase tracking-wide text-sm text-primary font-semibold">
                            Artist Pro
                        </div>
                        <h1 className="block mt-1 text-lg leading-tight font-medium text-black">
                            Unlock Unlimited Uploads
                        </h1>
                        <p className="mt-2 text-gray-500">
                            Get access to unlimited song uploads for a full year.
                        </p>
                        <div className="mt-4 flex items-baseline gap-2">
                            <span className="text-3xl font-bold text-gray-900">₹1500</span>
                            <span className="text-lg text-gray-400 line-through">₹2700</span>
                            <span className="text-gray-500">/year</span>
                        </div>
                        <div className="mt-6">
                            <button
                                onClick={handleSubscribe}
                                disabled={loading}
                                className="w-full bg-primary text-primary-foreground font-bold py-2 px-4 rounded hover:bg-primary/90 focus:outline-none focus:shadow-outline disabled:opacity-50"
                            >
                                {loading ? "Processing..." : "Upgrade Now"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PricingPage;
